<script setup>
import { computed } from 'vue';

const props = defineProps({
    options: {
        type: Object,
        required: true,
    },
    series: {
        type: Array,
        required: false,
        default: () => [],
    },
});

const chartOptions = computed(() => {
    if (props.series.length > 0) {
        return {
            ...props.options,
            series: props.series,
        };
    }

    return props.options;
});
</script>

<template>
    <apexchart
        :type="chartOptions.chart.type"
        :height="chartOptions.chart.height"
        :series="chartOptions.series"
        :options="chartOptions"
    />
</template>
